module.exports = __webpack_public_path__ + "static/media/arrow.75cac941.svg";